module.exports = __webpack_public_path__ + "assets/images/delete-trash-icon.0416d3f2b3eaeb5e5fbaee7b533ee26f.svg";